/* DSL Footer collapse — convert footer column h-elements to expandable accordions on mobile */
(function(){
  if (!window.matchMedia("(max-width: 749px)").matches) return;
  document.querySelectorAll(".footer-block__heading, .footer__column h2").forEach(function(h){
    if (h.dataset.collapsified) return;
    var details = document.createElement("details");
    var summary = document.createElement("summary");
    summary.textContent = h.textContent;
    summary.className = h.className;
    details.appendChild(summary);
    var content = document.createElement("div");
    content.className = "footer-block__content";
    var sib = h.nextElementSibling;
    while (sib) {
      var nxt = sib.nextElementSibling;
      content.appendChild(sib);
      sib = nxt;
    }
    details.appendChild(content);
    h.replaceWith(details);
    summary.dataset.collapsified = "1";
  });
})();